<template>
  <v-dialog v-model="dialog" persistent fullscreen>
    <v-toolbar>
      <v-toolbar-title
        >{{ $route.meta.nameDrawer }} Nº
        {{ $route.params.id_invoice }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn icon @click="$printCard()"><v-icon>mdi-printer</v-icon></v-btn>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <div v-if="!invoice" class="text-center pa-10">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
      <div class="pa-4" v-else id="print-card">
        <v-card
          light
          class="pa-10 d-flex flex-column mx-auto"
          width="794"
          height="1123"
        >
          <div>
            <v-row>
              <v-col cols="12" sm="6">
                <img
                  class="my-3"
                  width="160"
                  src="https://s3-eu-west-1.amazonaws.com/sga-pro/logos/sga_backg_white.png"
                />
              </v-col>
              <v-col cols="12" sm="6" class="text-right">
                <h1>{{ $t("invoice") }}</h1>
                <div class="overline">
                  {{ $t("date") }} {{ invoice.date_register | formatDate }}
                </div>
                <strong> {{ $t("invoiceNum") }}{{ invoice.id }}</strong>
              </v-col>
            </v-row>
          </div>
          <v-divider light></v-divider>
          <div>
            <v-row>
              <v-col cols="12" sm="6">
                <h3>{{ $t("invoiceUseLicense") }}</h3>
                <!-- <h4>Platform by TITANS SOFTWARE.</h4> -->
                <p class="caption">
                  {{ $t("invoiceDesctiption") }}
                </p>
                <div class="caption">
                  <span class="overline">
                    {{ $t("invoiceServiceProvider") }}
                  </span>
                  <br />
                  TITANS SOFTWARE CORP, 5 Cork Street, Belize City, Zip 2204.
                  Belize.
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="caption">
                <h3 class="overline">{{ $t("invoiceBill") }}</h3>
                <div class="d-flex justify-space-between">
                  <div>{{ $t("invoiceAccNumber") }}</div>
                  <div>{{ invoice.id_operator }}</div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>{{ $t("invoiceClient") }}</div>
                  <div class="text-right">{{ invoice.name_operator }}</div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>{{ $t("invoiceDomain") }}</div>
                  <div class="text-right">
                    {{ invoice.db_name.toUpperCase() }}
                  </div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>{{ $t("invoiceAddress") }}</div>
                  <div class="text-right">
                    {{ invoice.address }}, {{ invoice.number }}
                  </div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>{{ $t("invoiceCityState") }}</div>
                  <div class="text-right">
                    {{ invoice.name_city }} - {{ invoice.name_state }}
                  </div>
                </div>
                <v-divider light></v-divider>
                <div class="d-flex justify-space-between">
                  <div>{{ $t("invoiceZipcode") }}</div>
                  <div class="text-right">
                    {{ invoice.zip_code }}
                  </div>
                </div>
                <v-divider light></v-divider>
              </v-col>
            </v-row>
          </div>
          <v-simple-table light class="invoice">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="black white--text text-left">
                    {{ $t("invoiceDateStart") }}
                  </th>
                  <th class="black white--text text-left">
                    {{ $t("invoiceDateEnd") }}
                  </th>
                  <th class="black white--text text-left">
                    {{ $t("invoicePlanDescription") }}
                  </th>
                  <!-- <th class="black white--text text-right">Unit Price (%)</th> -->
                  <th class="black white--text text-right">
                    {{ $t("invoiceTotalPrice") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ invoice.date_start | formatDate }}</td>
                  <td>{{ invoice.date_end | formatDate }}</td>
                  <td>
                    {{ invoice.category }} ({{ invoice.value_unitary }}) <br />
                    <!-- R$ {{ invoice.gross_value }} -->
                  </td>
                  <!-- <td class="text-right">{{ invoice.value_unitary }}</td> -->
                  <td class="text-right">
                    {{
                      ((invoice.gross_value * invoice.value_unitary) / 100)
                        | decimalAdjustment
                    }}
                  </td>
                </tr>
                <!-- Resume -->
                <tr>
                  <td colspan="2" style="border-bottom: 0px"></td>
                  <td
                    class="
                      text-right
                      font-weight-bold
                      black
                      white--text
                      caption
                    "
                  >
                    {{ $t("invoiceSubTotal") }}
                  </td>
                  <td class="text-right">
                    {{
                      ((invoice.gross_value * invoice.value_unitary) / 100)
                        | decimalAdjustment
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="border-bottom: 0px"></td>
                  <td
                    class="
                      text-right
                      font-weight-bold
                      black
                      white--text
                      caption
                    "
                  >
                    {{ $t("invoiceAddition") }}
                  </td>
                  <td class="text-right">
                    {{ invoice.addition }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="border-bottom: 0px"></td>
                  <td
                    class="
                      text-right
                      font-weight-bold
                      black
                      white--text
                      caption
                    "
                  >
                    {{ $t("invoiceDiscount") }}
                  </td>
                  <td class="text-right">
                    {{ invoice.discount }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="border-bottom: 0px"></td>
                  <td
                    class="
                      text-right
                      font-weight-bold
                      black
                      white--text
                      caption
                    "
                  >
                    Total
                  </td>
                  <td class="text-right">{{ invoice.value_invoice }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider class="mt-10"></v-divider>
          <div class="body-2 py-2">
            <strong>{{ $t("invoiceObservation") }} </strong>
            {{ invoice.observation }}
          </div>
          <v-divider class="mb-2"></v-divider>
          <div
            class="
              d-flex
              pb-4
              flex-grow-1
              align-end
              text-center
              caption
              justify-center
              align-end
            "
          >
            {{ $t("invoiceThankYou") }} <br />
            {{ $t("invoiceProductCompany") }}
          </div>
        </v-card>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "views-backoffice-administrator-system-invoices-invoice",
  data: () => ({
    id_invoice: "",
    invoice: "",
  }),
  async mounted() {
    this.id_invoice = this.$route.params.id_invoice;
    var response = await this.$request.post(
      "administrator/account/getInvoice",
      {
        id_invoice: this.id_invoice,
      }
    );
    if (response.length == 0) return;
    this.invoice = response.dados;
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    // Close Dialog
    closeDialog: function () {
      this.$store.commit("showDialog", false);
    },
  },
  filters: {
    formatDate: function (date) {
      return new Date(date).toLocaleDateString();
    },
    decimalAdjustment: function (num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
  },
};
</script>
<style lang="sass">
.invoice
  thead
    background: #000000
    tr th
      color: #ffffff !important
  tr:nth-child(even)
    background: rgba(255, 255, 255, 0.2)
  tr:nth-child(odd)
    background: rgba(255, 255, 255, 0.5 )
</style>